import React, {useEffect} from 'react';
import {useStores} from "../../../stores/Context";
import {observer} from "mobx-react";
import FlecheRevenirSvg from "../../../boiteAOutils/SVG/FlecheRevenirSvg";
import FlecheCercleSvg from "../../../boiteAOutils/SVG/FlecheCercleSvg";
import {createAxiosEntrepriseInstance} from "../../../axiosEntreprise";
import {useParams} from "react-router-dom";
import ModalPrimary from "../../../boiteAOutils/ModalPrimary";
import bibliothequeImagesModule from "../../Widgets/WidgetBibliothequeImages/ModuleSidebar/BibliothequeImagesModule";

const WidgetMessagesInterServices = observer( () => {
    const {ent} = useParams();
    const { messageInterServicesStore, uiStore, widgetStore, bibliothequeImagesStore} = useStores();
    const [nbMessages, setNbMessages] = React.useState(0);
    const [showModal, setShowModal] = React.useState(false);
    const cookieEntreprise = widgetStore.getCookie("currentEntrepriseInfos");
    const entrepriseInfos = (() => {
        if (!cookieEntreprise) return {};
        try { return JSON.parse(cookieEntreprise); } catch (_) {
            try { return JSON.parse(decodeURIComponent(cookieEntreprise)); } catch (__) { return {}; }
        }
    })();

    const axiosEntrepriseInstance = createAxiosEntrepriseInstance(ent);

    useEffect(() => {recupListMessagesInterServices();})

  const recupListMessagesInterServices = async () => {
      const res = await axiosEntrepriseInstance.get('/api/MI/ListeMiConfigurationTotem/' + widgetStore.idTotem + "/EN LIGNE");
      setNbMessages(res.data.length);
      return res.data.length;
  }

    const handleBtnViewHistory = () => {
        messageInterServicesStore.showAdd = false;
        messageInterServicesStore.showEdit = false
        messageInterServicesStore.handleOpenArchive()
    }

    const handleBtnViewAdd = () => {
        recupListMessagesInterServices().then((res) => {
            if (res >= 5 && entrepriseInfos.subscriber === false) {
                setShowModal(true);
            } else {
                messageInterServicesStore.showArchive = false;
                messageInterServicesStore.showEdit = false
                messageInterServicesStore.handleOpenAdd()
            }
        })
        // if (nbMessages>=5 && entrepriseInfos.subscriber === false) {
        //     setShowModal(true);
        // } else {
        //     messageInterServicesStore.showArchive = false;
        //     messageInterServicesStore.showEdit = false
        //     messageInterServicesStore.handleOpenAdd()
        // }
    }

    const handleBackHome = () => {
        messageInterServicesStore.showArchive = false;
        messageInterServicesStore.showAdd = false;
        messageInterServicesStore.showEdit = false
        uiStore.closeConsultingMode();
        bibliothequeImagesStore.handleCloseModuleImage();
    }

    return (
        <div className={"navBarWidgetBtnContent"}>

            <div className={"widgetsNavBarContentIcons"} onClick={() => handleBackHome("Lecture")}>
                <FlecheRevenirSvg width={40} height={40} couleur={"#FBFDFE"}/>
                <span className={"widgetsNavBarContentIconsText"}>Revenir</span>
            </div>

            <div className={"widgetsNavBarContentIcons"} onClick={handleBtnViewAdd}>
                <div className={"navBarWidgetBtnAdd"}>
                    <svg style={{width: "3em"}} viewBox="0 0 40 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 4.875V34.125" stroke="white" strokeWidth="4"/>
                        <path d="M5.37598 19.5H34.6245" stroke="white" strokeWidth="4"/>
                    </svg>
                </div>
            </div>

            <div className={"widgetsNavBarContentIcons"} onClick={handleBtnViewHistory}>
                <FlecheCercleSvg width={40} height={40} couleur={"#FBFDFE"}/>
                <span className={"widgetsNavBarContentIconsText"}>Archives</span>
            </div>{showModal ? (
            <ModalPrimary
                textTitle="Limite atteinte"
                textComment="Vous avez atteint la limite de 5 messages. Passez à l’abonnement pour en ajouter davantage."
                textBtnValidate="OK"
                textBtnCancel="Annuler"
                onCancel={() => setShowModal(false)}
                textURL="S'abonner"
                URL="https://www.seizo.fr/pricing-plans/list"
            />
        ) : ''}

        </div>
    );
});

export default WidgetMessagesInterServices;